import { StyledLogoContainer, StyledText } from './MainScreen.styles'

export const Story = () => {
    return (
        <StyledLogoContainer>
        <StyledText> Many people in their lives have a moment when they reflect on what they can do for the world. 
            <br></br>
            One of the things that is possible is to give something that the world needs. 
            <br></br>
            There was only one conclusion: The world needs a game with a duck.
            <br></br><br></br>
            Time is money, and for ducks, time is bread. 
            <br></br>It's worth saving time downloading the game and piercing it into something more useful and if you're a duck ...
            <br></br> you can bake bread during this time.
            <br></br><br></br>
            Now stop reading. This is not Wikipedia. 
            <br></br>Do speedrun and break records! For the duck!
        </StyledText>
        </StyledLogoContainer>
    )
}

export default Story;